/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa form ladowanych do modali
 *
 * @export
 * @class ModalForm
 */
import { Form } from "./Form.class";

export class ModalForm {
	constructor() {
		this.modalObj = null;
		this.modalId = null;
		this.modalForm = null;
		this.modalFormAction = null;
		this.onFormReload = function () {
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja
	// ****************************************************************************************************
	initModalForm(modalId, formAction) {
		var that = this;
		that.modalObj = $(modalId);
		that.modalId = modalId;
		that.modalFormAction = (formAction === undefined) ? null : formAction;
		that.prepareModalFormEvents();
	}
	// ****************************************************************************************************
	// Przygotowanie modalu
	// ****************************************************************************************************
	prepareModalFormEvents() {
		var that = this;
		that.modalObj.one('show.bs.modal', function () {
		}).on('shown.bs.modal', function () {
			var srcUrl = that.modalObj.data('load-initial-html');
			var initialMethod = (that.modalObj.data('initial-method')) ? that.modalObj.data('initial-method') : "GET";
			if (!srcUrl) {
				setTimeout(function () { that.modalObj.modal('hide'); }, 1500);
				console.error('Brak adresu wskazującego na treć do załadowania.');
			}
			else {
				toolsObj.ajaxLoadData({
					updateBrowserHistory: false,
					url: srcUrl,
					target: that.modalId + ' .modal-body',
					loadingMode: false,
					method: initialMethod,
					forceAjaxPageLoad: true,
					sourceOfError: 'ModalForm::prepareModalFormEvents',
					onComplete: function () {
						that.updateModalTitle();
						that.createModalForm();
						that.onFormReload();
					}
				});
			}
		}).on('hidden.bs.modal', function () {
			that.modalObj.find('.modal-body').html('<div class="loading static"><img class="verticallyCentred" src="/img/loading.gif"/></div>');
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja formularza
	// ****************************************************************************************************
	createModalForm() {
		var that = this;
		that.modalForm = new Form({
			selector: that.modalId + ' form',
			action: that.modalFormAction,
			onSubmit: function () {
				that.submitForm();
			}
		});
	}
	// ****************************************************************************************************
	// Obsługa wysłania formularza
	// ****************************************************************************************************
	submitForm() {
		var that = this;
		toolsObj.ajaxLoadData({
			updateBrowserHistory: false,
			url: that.modalForm.settings.action + '?' + $(that.modalForm.settings.selector).serialize(),
			target: that.modalId + ' .modal-body',
			loadingTarget: that.modalId + ' .modal-body',
			method: that.modalForm.settings.method,
			sourceOfError: 'ModalForm::submitForm',
			onComplete: function () {
				that.createModalForm();
				that.onFormReload();
			}
		});
	}
	// ****************************************************************************************************
	// Uaktualnij tytu modalu
	// ****************************************************************************************************
	updateModalTitle() {
		var that = this;
		var newTitleObj = $(that.modalId + ' .modal-body [data-modal-title]');
		if (newTitleObj.length > 0) {
			$(that.modalId + ' .modal-header h5').html(newTitleObj.data('modal-title'));
		}
		else {
		}
	}
}